import React, { useEffect, useState } from 'react';
import { Box, TextField, Button, Typography } from '@mui/material';
import Select from 'react-select';
import countries from 'i18n-iso-countries';
import enLocale from 'i18n-iso-countries/langs/en.json';

countries.registerLocale(enLocale);

const EditCategoryForm = ({
  value,
  setValue,
  slug,
  setSlug,
  shortCode,
  setShortCode,
  imageFile,
  setImageFile,
  existingImageUrl,
  onUpdate,
  onCancel
}) => {
  const [countryOptions, setCountryOptions] = useState([]);
  const [selectedCountry, setSelectedCountry] = useState(null);

  useEffect(() => {
    const countryNames = countries.getNames('en', { select: 'official' });
    const options = Object.entries(countryNames).map(([code, label]) => ({
      value: code,
      label,
    }));
    setCountryOptions(options);
  }, []);

  // Sync dropdown selection with shortCode value if it matches an ISO code
  useEffect(() => {
    if (!shortCode) {
      setSelectedCountry(null);
      return;
    }
    const matchedOption = countryOptions.find(
      (option) => option.value.toLowerCase() === shortCode.toLowerCase()
    );
    setSelectedCountry(matchedOption || null);
  }, [shortCode, countryOptions]);

  const handleCountrySelect = (selected) => {
    setSelectedCountry(selected);
    if (selected) {
      setShortCode(selected.value);
    }
  };

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', mt: 2 }}>
      <TextField
        label="Edit Category Name"
        variant="outlined"
        fullWidth
        value={value}
        onChange={(e) => setValue(e.target.value)}
        sx={{ mb: 2 }}
      />

      <TextField
        label="Edit Category Slug"
        variant="outlined"
        fullWidth
        value={slug}
        onChange={(e) => setSlug(e.target.value)}
        sx={{ mb: 2 }}
      />

      {/* Country dropdown to set shortCode */}
      <Select
        options={countryOptions}
        onChange={handleCountrySelect}
        value={selectedCountry}
        placeholder="Select a country to set ShortCode"
        isClearable
        styles={{ container: (base) => ({ ...base, marginBottom: 16 }) }}
      />

      <TextField
        label="Edit ShortCode"
        variant="outlined"
        fullWidth
        value={shortCode}
        onChange={(e) => setShortCode(e.target.value)} // editable manually
        sx={{ mb: 2 }}
      />

      {existingImageUrl && (
        <Box sx={{ mb: 2 }}>
          <Typography variant="subtitle2" sx={{ mb: 1 }}>
            Existing Image:
          </Typography>
          <img
            src={existingImageUrl}
            alt="Category"
            style={{ maxWidth: '150px', borderRadius: 4 }}
          />
        </Box>
      )}

      <input
        type="file"
        accept="image/*"
        onChange={(e) => setImageFile(e.target.files?.[0] || null)}
        style={{ marginBottom: 16 }}
      />

      <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
        <Button onClick={onUpdate} color="primary" variant="contained">
          Update
        </Button>
        <Button onClick={onCancel} color="secondary" variant="outlined">
          Cancel
        </Button>
      </Box>
    </Box>
  );
};

export default EditCategoryForm;
